import {Doughnut} from "react-chartjs-2";
import React, {FC} from "react";
import {useTheme} from "@material-ui/core";

const chartOptions = {
    animation: {
        duration: 0
    },
    cutoutPercentage: 80,
    maintainAspectRatio: false,
    legend: {
        display: false,
        position: "right"
    },
    elements: {
        arc: {
            borderWidth: 0,
            weight: 0
        }
    }
};

type PropsType = {
    data: Array<number | string>,
    labels: Array<string>,
    symbol?: string;
    toLocalString?: boolean
}
const DoughnutChart: FC<PropsType> = ({data, labels, symbol, toLocalString}) => {
    const theme = useTheme()

    const getColors = (data: Array<number | string>) => {
        const result: string[] = []
        let colorIndex = 0
        const colors = [
            theme.palette.secondary.main,
            '#818892',
            '#1565C0',
            '#E0E0E0'
        ]

        data.forEach((i) => {
            if (colorIndex === 3) colorIndex = 0
            result.push(colors[colorIndex])
            colorIndex++
        })
        return result
    }

    const chartData = {
        maintainAspectRatio: false,
        responsive: true,
        labels: labels,
        datasets: [
            {
                data: data,
                backgroundColor: getColors(data),
                borderColor: theme.palette.background.paper,
                borderWidth: 0
            }
        ]
    };

    const textCenter = {
        id: 'textCenter',
        beforeDatasetsDraw(chart: any, args: any, pluginOptions: any) {
            const { ctx, data } = chart
            ctx.save()
            ctx.font = 'bold 24px sans-serif'
            ctx.fillStyle = '#FFF'
            ctx.textAlign = 'center'
            ctx.textBaseline = 'middle'
            const {x, y} = chart.getDatasetMeta(0).data[0]._view
            let sum = data.datasets[0].data.reduce((acc: any, num: any) => Number(acc) + Number(num), 0)
            if (symbol) {
                if (toLocalString) {
                    sum = sum.toLocaleString() + symbol
                } else {
                    sum = sum + symbol
                }
            }
            ctx.fillText(sum, x, y)
        }
    }
    return (
        <Doughnut
            data={chartData}
            options={chartOptions}
            plugins={[textCenter]}
        />
    )
}

export default DoughnutChart